<template>
  <div>
    <ListShell>
      <div id="tabel" class="my-table">
        <div style="display:flex;display:-webkit-flex;margin-botton:30px;">
          <div style="flex:1">
            <slot name="Filter"></slot>
          </div>
        </div>
        <div :class="titleClass">
          <label style="font-weight: bold;">{{ title }}</label>
          <el-button
            style="float: right;margin-bottom:10px;margin-left:10px; "
            v-if="MultipleSel && is_admin"
            size="small"
            type="primary"
            :disabled="multipleSelection.length === 0"
            @click="multipleDelete"
            >批量删除</el-button
          >
          <el-button
            style="margin-left:78%;margin-top:10px;"
            v-if="title === '告警记录'"
            size="small"
            :disabled="multipleSelection.length === 0"
            @click="multipleModify"
            >批量修改</el-button
          >
          <slot name="Fresh"></slot>
        </div>
        <el-table
          :header-cell-style="{ background: '#f5f7fa' }"
          :data="tableData"
          style="width: 100%;margin-top:20px;"
          align="center"
          :size="size"
          border
          @selection-change="handleSelectionChange"
        >
          <!-- 多选列 -->
          <el-table-column
            v-if="MultipleSel"
            type="selection"
            width="55"
          ></el-table-column>

          <!-- 按表头输出列 -->
          <el-table-column
            v-for="(item, index) in tanle"
            :key="index"
            :label="item.label"
            align="center"
            :width="item.width"
          >
            <template slot-scope="scope">
              <span v-if="item.status === 'alarmEvent'">
                <div style="display:inline-block;">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="scope.row[item.name]"
                    placement="left-start"
                  >
                    <a style="top: 4px;">
                      {{ scope.row[item.name].slice(0, 10) }}
                    </a>
                  </el-tooltip>
                </div>
              </span>
              <span v-else-if="item.status === 'alarmLevel'">
                <div style="display:inline-block;">
                  <el-tag
                    type="info"
                    v-if="scope.row[item.name] === '未分类'"
                    >{{ scope.row[item.name] }}</el-tag
                  >
                  <el-tag
                    style="top: 4px;color:#483D8B"
                    color="#E6E6FA"
                    v-if="scope.row[item.name] === '信息'"
                    >{{ scope.row[item.name] }}</el-tag
                  >
                  <el-tag
                    style="top: 4px;color:#808000"
                    color="#FFFFCC"
                    v-if="scope.row[item.name] === '警告'"
                    >{{ scope.row[item.name] }}</el-tag
                  >
                  <el-tag
                    type="warning"
                    v-if="scope.row[item.name] === '一般'"
                    >{{ scope.row[item.name] }}</el-tag
                  >
                  <el-tag
                    type="danger"
                    v-if="scope.row[item.name] === '严重'"
                    >{{ scope.row[item.name] }}</el-tag
                  >
                  <el-tag
                    style="top: 4px;color:#C71585"
                    color="#FFF0F5"
                    v-if="scope.row[item.name] === '灾难'"
                    >{{ scope.row[item.name] }}</el-tag
                  >
                </div>
              </span>
              <span v-else-if="item.status === 'alarmStatus'">
                <div style="display:inline-block;">
                  <el-tag
                    type="danger"
                    v-if="scope.row[item.name] === '未处理'"
                    >{{ scope.row[item.name] }}</el-tag
                  >
                  <el-tag
                    type="info"
                    v-else-if="scope.row[item.name] === '处理中'"
                    >{{ scope.row[item.name] }}</el-tag
                  >
                  <el-tag
                    type="success"
                    v-else-if="scope.row[item.name] === '已解决'"
                    >{{ scope.row[item.name] }}</el-tag
                  >
                </div>
              </span>
              <span v-else-if="item.status === 'taskStatus'">
                <div style="display:inline-block;">
                  <el-tag
                    type="info"
                    v-if="scope.row[item.name] === '取消'"
                    >{{ scope.row[item.name] }}</el-tag
                  >
                  <el-tag
                    type="danger"
                    v-if="scope.row[item.name] === '失败'"
                    >{{ scope.row[item.name] }}</el-tag
                  >
                  <el-tag
                    type="primary"
                    v-else-if="scope.row[item.name] === '进行中'"
                    >{{ scope.row[item.name] }}</el-tag
                  >
                  <el-tag
                    type="success"
                    v-else-if="scope.row[item.name] === '已完成'"
                    >{{ scope.row[item.name] }}</el-tag
                  >
                  <el-tag
                    type="warning"
                    v-else
                  >{{ scope.row[item.name] }}</el-tag>
                </div>
              </span>
              <span v-else-if="item.status === 'copyStatus'">
                <div style="display:inline-block;">
                  <span>{{ scope.row[item.name] }}</span>
                  <el-tooltip
                    v-if="scope.row[item.name]"
                    effect="dark"
                    content="复制下载链接"
                    placement="top"
                  >
                    <el-button
                      type="text"
                      icon="el-icon-document-copy"
                      @click="copyToClipboard(scope.row[item.name])"
                      style="color: #409EFF; font-size: 14px;"
                    ></el-button>
                  </el-tooltip>
                </div>
              </span>
              <span v-else-if="item.status === 'tagStatus'">
                <div style="display: flex; flex-direction: column; align-items: center; padding: 5px;">
                  <template v-if="scope.row[item.name]">
                    <el-tag
                      v-for="(tag, index) in scope.row[item.name].split(',')"
                      :key="index"
                      style="margin-bottom: 5px; width: fit-content;"
                    >
                      {{ tag }}
                    </el-tag>
                  </template>
                </div>
              </span>
              <span v-else-if="item.status === 'romTag'">
                <div style="display: flex; flex-direction: column; align-items: center; padding: 2px;">
                  <template v-if="scope.row[item.name]">
                    <el-tag
                      v-for="(tag, index) in scope.row[item.name].split(',')"
                      :key="index"
                      :style="tag === '设备型号未添加' ?
                        'margin-bottom: 2px; width: fit-content; background-color: #ffebee; color: #e57373; border-color: #ffebee;' :
                        'margin-bottom: 2px; width: fit-content; background-color: #d6eaff; color: #4682b4; border-color: #d6eaff;'"
                    >
                      {{ tag.split('|')[0] }}
                      <el-tooltip
                        v-if="(tag.includes('最新正式版本') || tag.includes('最新Beta版本') || tag.includes('最新LTS版本')) && !tag.includes('最新过渡版本')"
                        effect="dark"
                        content="复制版本发布地址"
                        placement="top"
                      >
                        <i
                          class="el-icon-document-copy"
                          style="cursor: pointer;"
                          @click="copyFirmwareUrl(tag)"
                        ></i>
                      </el-tooltip>
                    </el-tag>
                  </template>
                </div>
              </span>
              <span v-else-if="item.status === 'copyFirmware'">
                <div style="display:inline-block;">
                  <span>{{ scope.row[item.name] }}</span>
                  <el-tooltip
                    v-if="scope.row[item.name]"
                    effect="dark"
                    :content="`复制${item.type === 'stable' ? '正式' : item.type === 'lts' ? 'LTS' : item.type === 'transitional' ? '过渡' : 'Beta'}版本发布地址`"
                    placement="top"
                  >
                    <el-button
                      type="text"
                      icon="el-icon-document-copy"
                      @click="copyFirmwareUrl(scope.row.name, item.type)"
                      style="color: #409EFF; font-size: 14px;"
                    ></el-button>
                  </el-tooltip>
                </div>
              </span>
              <span v-else>
                <div style="display:inline-block;">
                  <slot :name="`slot-${item.name}`" v-bind:item="scope.row">
                    <a style="top: 4px;" :key="item.name">{{ scope.row[item.name] }}</a>
                  </slot>
                </div>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            :width="operat.length * 40 + 80"
            align="center"
            fixed="right"
            v-if="operat.length !== 0"
          >
            <template slot-scope="scope">
              <template
                v-for="(operatBtn, index) in operat"
                style=" display: flex;justify-content:space-around"
              >
                <template v-if="operatBtn.text === 'Deletedata'">
                  <i
                    :key="index"
                    class="el-icon-delete size"
                    @click="operatEvent(operatBtn, scope.row)"
                  />
                </template>
                <template v-if="operatBtn.text === 'Setting'">
                  <i
                    :key="index"
                    class="el-icon-setting size"
                    @click="operatEvent(operatBtn, scope.row)"
                  />
                </template>
                <template v-else-if="operatBtn.text === 'Download'">
                  <i
                    :key="index"
                    class="el-icon-download size"
                    @click="operatEvent(operatBtn, scope.row)"
                  ></i>
                </template>
                <template v-else-if="operatBtn.text === 'Detail'">
                  <el-button
                    :key="index"
                    @click="operatEvent(operatBtn, scope.row)"
                    type="primary"
                    >详情</el-button
                  >
                </template>
                <template v-else-if="operatBtn.text === 'Edit'">
                  <i
                    :key="index"
                    class="el-icon-edit-outline size"
                    @click="operatEvent(operatBtn, scope.row)"
                  />
                </template>
              </template>
            </template>
          </el-table-column>

          <div slot="empty">暂无数据</div>
        </el-table>
      </div>
    </ListShell>
    <Pagination ref="pagination" :total="total" @serch="changePage"></Pagination>
  </div>
</template>

<script>
import Pagination from "./Pagination";
import ListShell from "./ListShell";
import { MAINTENANCE_DOMAIN } from "@/utils/options.js";

export default {
  components: {
    Pagination,
    ListShell
  },
  props: {
    title: {
      type: String
    },
    size: {
      type: String
    },
    // 类表表头数据
    tanle: {
      required: true
    },
    titleClass: {
      type: String
    },
    is_admin: {
      type: Boolean,
      default: true
    },
    // 操作栏数据
    operat: {
      default() {
        return [
          {
            text: "Edit",
            eventName: "edit"
          },
          {
            text: "Download",
            eventName: "download"
          },
          {
            text: "Deletedata",
            eventName: "deletedata"
          }
        ];
      }
    },
    // 请求url
    url: {
      type: String,
      required: true
    },
    // 请求后数据初步处理
    afterList: {
      type: Function,
      default(data) {
        return data;
      }
    },
    // 请求额外参数
    data: {
      type: Object,
      default() {
        return {};
      }
    },
    // 显示多选删除项
    MultipleSel: {
      type: Boolean,
      default: false
    },
    // 更新列表数据
    update: {
      type: Number,
      default: 0
    },
    useBatchSuffix: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      tableData: [], //列表数据选项，从服务器获取
      total: 0,
      row: 10,
      pagenumber: 1,
      multipleSelection: [], //多选存储器
      ID: "",
      str: "",
      allData: ""
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      //获取列表数据
      this.data["rows"] = this.row;
      this.data["page"] = this.pagenumber;
      this.$http.get(
        this.url,
        this.data,
        data => {
          // console.log("List.data" ,data)
          this.tableData = this.afterList(data.data.results);
          this.total = Number(data.data.count);
        },
        () => {
          this.tableData = [];
        }
      );
      if (this.url === "menus/") {
        this.$http.get("menus/", {}, data => {
          this.$store.commit("saveMenuGroup", data.data.results);
        });
      }
      if (this.url === "roles/") {
        this.$http.get("roles/", {}, data => {
          this.$store.commit("saveRoleGroup", data.data.results);
        });
      }
      if (this.url === "structures/") {
        this.$http.get("structures/", {}, data => {
          this.$store.commit("saveDepartmentGroup", data.data.results);
        });
      }
      this.loading = false;
    },
    // 页数条数更改
    changePage(row, pagenumber) {
      this.row = row;
      this.pagenumber = pagenumber;
      this.getList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      let multipleSelectionID = [];
      for (let i in val) {
        multipleSelectionID[i] = val[i].id;
      }
      this.ID = multipleSelectionID.join(",");
    },
    // 操作事件触发器
    operatEvent(btnObj, ItemData) {
      ItemData = Object.assign({}, ItemData);
      if (btnObj.PretreatMethod) this[btnObj.PretreatMethod](btnObj, ItemData);
      else this.$emit(btnObj.eventName, ItemData);
    },
    // multipleModify() {
    //   this.ID;
    // },
    multipleDelete() {
      let url = this.useBatchSuffix ? this.url + "batch/" : this.url;
      this.$http["multipleDelete"](
        url,
        {
          data: this.ID
        },
        () => {
          this.$baseNotice.message("删除成功");
          // 检查是否有监听 batchPost 事件
          const hasListener = this.$listeners && this.$listeners.batchPost;
          if (hasListener) {
            // 如果有监听器，只触发事件，由父组件负责刷新
            this.$emit('batchPost');
          } else {
            // 如果没有监听器，自己刷新列表
            this.getList();
          }
        }
      );
    },
    backFirstPage(){
      this.$refs.pagination.currentPage = 1;
      this.pagenumber = 1;
    },
    copyToClipboard(text) {
      const input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand('copy');
        this.$message({
          message: '复制成功',
          type: 'success'
        });
      } catch (err) {
        this.$message({
          message: '复制失败',
          type: 'error'
        });
      }
      document.body.removeChild(input);
    },
    copyFirmwareUrl(tagOrName, releaseType) {
      let modelName;
      let versionType;

      if (releaseType) {
        // 处理第二种调用方式
        modelName = tagOrName;
        if (releaseType === 1 || releaseType === 'stable') {
          versionType = 'stable';
        } else if (releaseType === 2 || releaseType === 'beta') {
          versionType = 'beta';
        } else if (releaseType === 3 || releaseType === 'lts') {
          versionType = 'lts';
        } else if (releaseType === 4 || releaseType === 'transitional') {
          versionType = 'transitional';
        } else {
          versionType ='notfound';
        }
      } else {
        // 处理第一种调用方式
        modelName = tagOrName.split('|')[1];
        if (tagOrName.includes('最新正式版本')) {
          versionType = 'stable';
        } else if (tagOrName.includes('最新Beta版本')) {
          versionType = 'beta';
        } else if (tagOrName.includes('最新LTS版本')) {
          versionType = 'lts';
        } else if (tagOrName.includes('最新过渡版本')) {
          versionType = 'transitional';
        } else {
          versionType = 'notfound';
        }
      }

      if (versionType === 'notfound') {
        this.$message({
          message: '未识别的版本类型',
          type: 'warning'
        });
        return; // 直接返回，不执行复制操作
      }

      const url = `${MAINTENANCE_DOMAIN}/firmware/release/${versionType}?model_name=${modelName}`;

      const input = document.createElement('input');
      input.value = url;
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand('copy');
        this.$message({
          message: '链接已复制到剪贴板',
          type: 'success'
        });
      } catch (err) {
        this.$message({
          message: '复制失败',
          type: 'error'
        });
      }
      document.body.removeChild(input);
    }
  },
  watch: {
    update() {
      this.getList();
    }
  }
};
</script>

<style lang="less" scoped>
.word-space {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 5px;
}
.size {
  font-size: 24px;
  margin-right: 20px;
}
.title {
  margin-top: 20px;
}
</style>
